import { createStore } from 'vuex'
import createHttp from "@/services/http";
import router from "@/router";

import translateEng from '@/assets/en_translates.json';
import translateSlo from '@/assets/si_translates.json';

export default createStore({
  state: {
    token: "",
    role: "",
    expiration: 0,
    isBusy: false,
    error: "",
    translates: {},
    appSettings: {},
    userlanguage: 'EN'
  },
  mutations: { 
    // Initialize store from localStorage
    initialiseStore(state) { 
      const tmpToken = localStorage.getItem('token')
      const tmpRole = localStorage.getItem('role')
      const tmpExp = localStorage.getItem('expiration')
      if(tmpToken) {
        state.token = tmpToken
        state.role = tmpRole
        state.expiration = tmpExp                
      }     
    },
    setBusy(state) {
      state.isBusy = true
    },
    clearBusy(state) {
       state.isBusy = false
    },
    setError: (state, error) => state.error = error,
    clearError: (state) => state.error = "",
    setUserlanguage(state,language) {
      state.userlanguage = language
    },    
    setTranslates(state,trans) {
      state.translates = trans;
    },
    // Save token and user info to state and localStorage
    setToken(state, model) {
      const exp = new Date(model.Expiration)
      const expNumber = Number(exp)
      localStorage.setItem('token', model.Token);
      localStorage.setItem('role', model.Role);
      localStorage.setItem('expiration', expNumber);
      state.token = model.Token
      state.role = model.Role
      state.expiration = expNumber
    },
    // Remove token and user info from state and localStorage
    clearToken(state) {
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      localStorage.removeItem('expiration')
      state.token = "";
      state.role = "";
      state.expiration = Date.now();
    }
  },
  getters: {
    // Check if user is authenticated and token is not expired
    isAuthenticated: (state) => {
      const isAuth = state.token.length > 0 && state.expiration > Date.now()
      const dateCheck = state.expiration > Date.now()
      return isAuth && dateCheck;
    },
    getToken: (state) => state.token,
    getRole: (state) => state.role,
    // Check if user has a specific role
    isInRole: (state) => (roleName) => {
       return state && state.role && state.role.includes(roleName);
     },    
    getUserlanguage: (state) => state.role,
    // Get translation for a key based on current language
    getTranslate: (state) => (key) => {
      if(state.userlanguage == 'EN') {
        return translateEng[key];
      } else if(state.userlanguage == 'SI') {
        return translateSlo[key];
      } else {
        return '';
      }
    }
  }, 
  actions: {
    // Set default language and initialize store
    InitMyStore: ( { commit } ) => {
      commit("setUserlanguage", 'SI');
    },
    // Login action: authenticate user and save token
    login: async ({ commit, getters }, model) => {
      try {
        commit("setBusy");
        commit("clearError");
        debugger;
        const http = createHttp(false); // unsecured
        if(http.headers==null) {
            http.headers = { 'Content-Type': 'application/json' }
        }
        const loginurl = process.env.VUE_APP_AUTH_FOLDER + "/LoginWebApp?=EN";
        const result = await http.post(loginurl, model);
        if (result.data.Success) {
          commit("setToken", result.data);
          router.push("/");
        }
        else {
          commit("setError", getters.getTranslate("authError"));
        }
      } catch {
        commit("setError", getters.getTranslate("authErrorSystem"));
      } finally {
        commit("clearBusy");
      }
    },

    removeErrorMessage: ({ commit }) => {
      commit("clearError");
    },
    changePassword: async ({ commit, getters }, model) => {
      try {
        debugger;
        commit("setBusy");
        commit("clearError");
        const http = createHttp(false); // unsecured
        if(http.headers==null) {
            http.headers = { 'Content-Type': 'application/json' }
        }
        const loginurl = process.env.VUE_APP_AUTH_FOLDER + "/ChangePassword";
        const result = await http.post(loginurl, model);
        if (result.status==200) {
          router.push("PasswordChanged");
        }
        else {
          commit("setError", getters.getTranslate("resetFaild"));
        }        
      } catch {
        commit("setError", getters.getTranslate("resetFaild"));
      } finally {
        commit("clearBusy");
      }

    },
    // Reset password action: send reset request and redirect
    resetPassword: async ({ commit, getters }, model) => {
      try {
        commit("setBusy");
        commit("clearError");
        const http = createHttp(false); // unsecured
        if(http.headers==null) {        
            http.headers = { 'Content-Type': 'application/json' }
        }
        const loginurl = process.env.VUE_APP_AUTH_FOLDER + "/ResetPassword";
        const result = await http.post(loginurl, model);
        if (result.status==200) {
          router.push("BackToLogin");
        }
        else {
          commit("setError", getters.getTranslate("resetFaild"));
        }
      } catch {
        commit("setError", getters.getTranslate("resetFaild"));
      } finally {
        commit("clearBusy");
      }
    },

    // Logout action: clear token and redirect to login
    logout: ({ commit }) => {
      commit("clearToken");
      router.push("/login");
    }
  }
})